const Auth = {
  login: '/auth/admin/login',
  // logout: ''
}

export default Auth;